import { useEffect, useState } from "react";
function resolvePromise(promise) {
    if (typeof promise === "function") {
        return promise();
    }
    return promise;
}
export function usePromise(promise, inputs) {
    const [{ error, result, pending }, setState] = useState({
        error: undefined,
        result: undefined,
        pending: true,
    });
    useEffect(() => {
        promise = resolvePromise(promise);
        if (!promise) {
            return;
        }
        let canceled = false;
        setState({
            error: undefined,
            result: undefined,
            pending: true,
        });
        promise.then((result) => !canceled &&
            setState({
                error: undefined,
                result: result,
                pending: false,
            }), (error) => !canceled &&
            setState({
                error: error,
                result: undefined,
                pending: false,
            }));
        return () => {
            canceled = true;
        };
    }, inputs);
    return [result, error, pending];
}
//# sourceMappingURL=usePromise.js.map